import React from 'react';

export interface Permissions extends Record<string, boolean | { [key: string]: boolean }> {
  dynamic?: {
    [key: string]: boolean;
  }
}

export const PermissionsContext = React.createContext<Permissions>({});
